import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import * as BiTmplDetail_18_s from './components';
import { useBiTmplDetailSteup } from '../../../store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-18',
  setup(__props) {

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const cmpName = computed(() => {
  return BiTmplDetail_18_s['BiTmplDetail_' + state.value.activeMenu[1]];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName.value)))
  ]))
}
}

})